
<!-- popup for addnew Notes -->
<modal #createNotesModal id="createNotesModal">
    <modal-header>
        <div class="color-blue">{{'member-notes.NEW NOTES' | translate |translateKey}}</div>
        <div *ngIf="distributorInfo" class="distributorInformation text-right">
        <div *ngIf="distributorInfo.name" class="bold header-font color-black distributor-name ">
            {{distributorInfo | displayNameFormat}}
        </div>
        <div *ngIf="distributorInfo.displayName && distributorInfo.memberTypeId === memberTypeEnum.DISTRIBUTOR" class="bold">
            <span>{{distributorInfo.displayName | titlecase}}</span>
          </div>
        <div class="font14">
            <a *ngIf="distributorInfo?.distributorId"><i class="fa fa-copy" [copyToClipboard]="distributorInfo.distributorId"></i></a>
            <span class="color-black" *ngIf="distributorInfo.distributorId">{{distributorInfo.distributorId |distributorIdFormat}}</span>
            <span *ngIf="distributorInfo.level"> | {{distributorInfo.level}}</span>
        </div>
    </div>

    </modal-header>
    <modal-content>
        <form  *ngIf="createNotesForm" [formGroup]="createNotesForm" (ngSubmit)="saveNote(createNotesForm.valid)" class="col-xs-12" novalidate id="Create-Note-js">
            <div class="fboprofile-notes">
                <div class="floating-input col-md-6 no-padding">
                    <select id="notesType" float-label class="form-control" formControlName="notesType">
                      <!--<option>Type</option>-->
                      <option value="">{{'config-system.Select Notes Type' |translate |translateKey}}</option>
                        <option *ngFor="let noteType of memberNoteTypes" [value]="noteType.LookupID">{{noteType.ConfigKey}}</option>
                    </select>
                     <div class="alert-msg" *ngIf="!createNotesForm.controls['notesType'].valid  && createNotesForm.controls['notesType'].hasError('required') && (createNotesForm.controls['notesType'].touched || isSubmitted)">
                        {{'validation-message.Required'|translate |translateKey}}
                    </div>
                </div>

                <div class="floating-input floatLabelContainer clearboth textarea-msg">
                    <textarea float-label tabindex="0" id="notesSummary" class="form-control overflow-x-hidden" formControlName="notesSummary"
                        placeholder="{{'ticketing-system.Summary'|translate |translateKey}}" rows="2"  maxlength="201"></textarea>
                     <div class="alert-msg" *ngIf="!createNotesForm.controls['notesSummary'].valid  && createNotesForm.controls['notesSummary'].hasError('required') && (createNotesForm.controls['notesSummary'].touched || isSubmitted)">
                            {{'validation-message.Required'|translate |translateKey}}
                     </div>

                    <!-- <div class="alert-msg" *ngIf="createNotesForm.controls['notesSummary'].value.length ==200">
                        {{'validation-message.You reached the approximate range of 200 characters'|translate |translateKey}}
                    </div>  -->
                </div>
                <div class="floating-input floatLabelContainer textarea-msg">
                    <textarea float-label tabindex="0" id="notesDescription" class="form-control overflow-x-hidden" formControlName="notesDescription"
                        placeholder="{{'ticketing-system.Description'|translate}}" rows="5" maxlength="1000"></textarea>
                      <div class="alert-msg" *ngIf="!createNotesForm.controls['notesDescription'].valid  && createNotesForm.controls['notesDescription'].hasError('required') && (createNotesForm.controls['notesDescription'].touched || isSubmitted)" >
                        {{'validation-message.Required'|translate |translateKey}}
                    </div>
                    <!-- <div class="alert-msg" *ngIf="createNotesForm.controls['notesDescription'].value.length ==999">
                        {{'validation-message.You reached the approximate range of 1000 characters'|translate |translateKey}}
                    </div>  -->

                </div>
            </div>
            <div class="pull-right">
                <button class="btn blue-button" tabindex="0" type="submit">
                    {{'config-system.ADD' |translate}}
                </button>
                <button class="btn grey-button" tabindex="0" type="button" (keyup.enter)="closePopUp()" (click)="closePopUp()">
                    {{'config-system.CANCEL' |translate}}
                </button>
            </div>
        </form>
    </modal-content>
</modal>
<!-- end -->

<modal #createAttachmentsModal id="createAttachmentsModal">
    <modal-header>
        <div class="color-blue">{{'config-system.CREATE ATTACHMENTS' |translate}}</div>
         <div *ngIf="distributorInfo" class="distributorInformation text-right">
        <div class="bold header-font color-black distributor-name ">
            {{distributorInfo | displayNameFormat}}
        </div>
        <div *ngIf="distributorInfo.displayName && distributorInfo.memberTypeId === memberTypeEnum.DISTRIBUTOR" class="bold">
            <span>{{distributorInfo.displayName | titlecase}}</span>
          </div>
        <div class="font14">
            <a *ngIf="distributorInfo?.distributorId"><i class="fa fa-copy" [copyToClipboard]="distributorInfo.distributorId"></i></a>
            <span class="color-black" *ngIf="distributorInfo.distributorId">{{distributorInfo.distributorId |distributorIdFormat}}</span>
            <span *ngIf="distributorInfo.level"> | {{distributorInfo.level}}</span>
        </div>
    </div>
    </modal-header>
    <modal-content>
        <div class="table-section">
            <!-- Attachment table -->
            <div class="row-sameheight-block">
                <div class="col-xs-12 col-md-8 pad-top-10 column-equal">
                    <div class="table-section">
                        <div class="table-responsive">
                            <table class="table table-striped custab">
                                <thead>
                                    <tr>
                                        <th class="col-md-10">{{'ticketing-system.File Name' |translate | translateKey}}&nbsp;</th>
                                        <th>{{'ticketing-system.Actions' |translate | translateKey}}&nbsp;</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let item of uploader.queue">
                                        <td>{{ item?.file?.name }}</td>
                                        <td class="options">
                                            <i style="color: #337ab7;" *ngIf="showDocument" class="fa text-primary fa-download pr-10" (click)="downloadDocument(item.url,item.fileName)"
                                                title="{{'documentlibrary.download '|translate | translateKey}}">
                                            </i>
                                            <i class="line-height1-2 fa fa-trash" (click)="item.remove();attachmentsLength= attachmentsLength-1;" title="{{'ticketing-system.Delete'|translate | translateKey}}">
                                            </i>
                                        </td>
                                    </tr>
                                </tbody>
                                <!-- <tbody *ngIf="uploader?.queue?.length === 0">
                                    <tr>
                                        <td colspan="2" class="text-align-center"></td>
                                    </tr>
                                </tbody> -->
                                <tbody>
                                        <tr *ngIf="uploader?.queue?.length === 0">
                                                <td colspan="2" class="text-center">{{'member-notes.Max 15 attachments allowed' |translate | translateKey}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div class="col-xs-12 col-md-4 pad-top-10 column-equal">
                    <label tabindex="0" id="attachFile-btn" *ngIf="!(attachmentsLength >= 15)" (keyup.enter)="fileSelect.click()" for="attachFile" class="mar-left10 line-height2 btn btn-xs browse-btn right-16"
                        title="{{'ticketing-system.Choose File'|translate | translateKey}}">
                        <span aria-hidden="true">{{'ticketing-system.Choose File'|translate | translateKey}}</span>
                        <input #fileSelect type="file" id="attachFile" ng2FileSelect [uploader]="uploader" role="file" aria-label="browse" style="display: none;"
                        (change)="checkMaxAttachments()" multiple>
                    </label>
                </div>
            </div>
            <!-- /Attachment table end -->
        </div>
        <div class="pull-right mt-20">
            <button id="createAttach-btn" class="btn blue-button" tabindex="0" (keyup.enter)="saveAttachments()" (click)="saveAttachments()" [attr.disabled]="uploader.queue.length>0?null:''">
                {{'config-system.ADD' |translate}}
            </button>
            <button class="btn grey-button" tabindex="0"  (keyup.enter)="closeAttachmentPopUp()" (click)="closeAttachmentPopUp()">
                {{'config-system.CANCEL' |translate}}
            </button>
        </div>
    </modal-content>
</modal>

<!-- popup for delete icon -->
<modal #deleteAttachmentsModal id="deleteAttachmentsModal">
    <modal-header>
        <div class="color-blue">{{'config-system.DELETE ATTACHMENT' |translate |translateKey}}</div>
    </modal-header>
    <modal-content>
            <div class="">{{'config-system.Attachment will be deleted. Do you wish to continue?' |translate |translateKey}}</div>
            <div class="clearboth text-right mt-40">
                <button id="deleteAttachments" class="btn blue-button" tabindex="0" (keyup.enter)="deleteAttachments()" (click)="deleteAttachments()" >
                    {{'config-system.DELETE' |translate |translateKey}}
                </button>
                <button class="btn grey-button" tabindex="0" type="button"  (keyup.enter)="closeDeleteAttachmentPopUp()" (click)="closeDeleteAttachmentPopUp()">
                    {{'config-system.CANCEL' |translate |translateKey}}
                </button>
            </div>
    </modal-content>
</modal>
<section class="container">
    <div *ngIf="distributorInfo" class="distributorInformation text-right">
        <div class="bold header-font color-black distributor-name ">
            {{distributorInfo | displayNameFormat}}
        </div>
        <div *ngIf="distributorInfo.displayName && distributorInfo.memberTypeId === memberTypeEnum.DISTRIBUTOR" class="bold">
            <span>{{distributorInfo.displayName | titlecase}}</span>
          </div>
        <div class="font14">
            <a *ngIf="distributorInfo?.distributorId"><i class="fa fa-copy" [copyToClipboard]="distributorInfo.distributorId"></i></a>
            <span class="color-black" *ngIf="distributorInfo.distributorId">{{distributorInfo.distributorId |distributorIdFormat}}</span>
            <span *ngIf="distributorInfo.level"> | {{distributorInfo.level}}</span>
        </div>
    </div>
    <div class="w-80">
    <!-- Notes table -->
        <div class="text-left" *ngIf="_id && ([FBODetailPermissions[0]] | hasAccess : customerServiceAccessLevelId)" >
            <a autofocus="" tabindex="0" id="processor-btn" (click)="openCreateNotesModal()">
                <span class="glyphicon glyphicon-plus"></span> &nbsp;&nbsp;{{'member-notes.ADD NOTES' |translate |translateKey}}
            </a>
        </div>

        <div class="table-responsive">
            <table class="table table-striped custab member-notes">
                <thead>
                    <tr>
                         <th (click)="sortMemberNotes('createdByUserName')" class="pointer">{{'ticketing-system.Created By' |translate | translateKey}}&nbsp;
                             <i class="fa" [ngClass]="{'fa-sort': sortOrder != 'createdByUserName', 'fa-sort-asc': (sortOrder == 'createdByUserName' && !memberNotesSortOrder), 'fa-sort-desc': (sortOrder == 'createdByUserName' && memberNotesSortOrder) }"
                                        aria-hidden="true"> </i>
                         </th>
                         <th (click)="sortMemberNotes('createdDate')" class="pointer">{{'ticketing-system.Created Date' |translate | translateKey}}&nbsp;
                             <i class="fa" [ngClass]="{'fa-sort': sortOrder != 'createdDate', 'fa-sort-asc': (sortOrder == 'createdDate' && !memberNotesSortOrder), 'fa-sort-desc': (sortOrder == 'createdDate' && memberNotesSortOrder) }"
                                        aria-hidden="true"> </i>
                         </th>
                        <th>{{'ticketing-system.Timestamp' |translate | translateKey}}</th>
                         <th (click)="sortMemberNotes('lookupConfiguration')" class="pointer">{{'ticketing-system.Type' |translate | translateKey}}&nbsp;
                             <i class="fa" [ngClass]="{'fa-sort': sortOrder != 'lookupConfiguration', 'fa-sort-asc': (sortOrder == 'lookupConfiguration' && !memberNotesSortOrder), 'fa-sort-desc': (sortOrder == 'lookupConfiguration' && memberNotesSortOrder) }"
                                        aria-hidden="true"> </i>
                         </th>
                        <th>{{'ticketing-system.Summary' |translate | translateKey}}</th>
                        <th>{{'ticketing-system.Description' |translate | translateKey}}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let note of memberNotesInfo | paginate: {  id: 'memberNotes-pagination', itemsPerPage: pageSize, currentPage: memberNotesPageNumber, totalItems: memberNotesPageCount }">
                        <td>{{note.createdByUserName}} </td>
                        <td *ngIf="note.createdDate!='null'">{{note.monthDateFormat}}</td>
                        <td *ngIf="note.createdDate=='null'"></td>
                        <td *ngIf="note.createdDate!='null'">{{note.hoursDateFormat}}</td>
                        <td *ngIf="note.createdDate=='null'"></td>
                        <td *ngIf="note.noteTypeID == accountLookUpId">{{'ticketing-system.Account' |translate | translateKey}}</td>
                        <td *ngIf="note.noteTypeID == orderLookUpId">{{'ticketing-system.Orders' |translate | translateKey}}</td>
                        <td *ngIf="note.noteTypeID == AccountStatusChangeLookUpId">{{'ticketing-system.AccountStatusChange' |translate | translateKey}}</td>
                        <td *ngIf="note.noteTypeID == accountLookUpId && note.noteTypeID == orderLookUpId"></td>
                        <td>{{note.summary}}</td>
                        <td>
                           <div class="textarea-format">{{note.description}}</div> 
                        </td>
                    </tr>
                </tbody>
                 <tbody *ngIf="memberNotesInfo?.length===0">
                    <tr>
                        <td colspan="6" class="text-center">{{'customer-service.No Notes found.' |translate |translateKey}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="alert-white rounded grid-count">
                {{memberNotesPageCount}} {{'ticketing-system.record(s) found' |translate}}
               <pagination-controls [id]="paginationInstance1.id" (pageChange)="memberNotesPageChange($event)" class="pull-right"></pagination-controls>
           </div>

        <div class="clearfix text-left col-md-12 no-padding" *ngIf="_id">
            <a autofocus="" tabindex="0" id="processor-btn" (click)="openCreateAttachmentsModal()">
                <span class="glyphicon glyphicon-plus"></span> &nbsp;&nbsp;{{'member-notes.ADD ATTACHMENTS' |translate |translateKey}}
            </a>
        </div>

        <!-- <div class="no-padding">
                <span class="color-blue">{{'customer-service.ATTACHMENTS' |translate | translateKey}}</span>
        </div> -->
        <div class="table-section">
            <!-- Attachment table -->
            <div class="row-sameheight-block mb-20 row">
                <div class="col-xs-12 pad-top-10 column-equal">
                    <div class="table-section">
                        <div class="table-responsive member-attachments">
                            <table class="table table-striped custab">
                                <thead>
                                    <tr>
                                        <th class="col-md-10">{{'ticketing-system.File Name' |translate | translateKey}}&nbsp;</th>
                                        <th>{{'ticketing-system.Actions' |translate | translateKey}}&nbsp;</th>
                                    </tr>
                                </thead>
                                <tbody>
                                        <tr *ngFor="let item of files  | paginate: { id:'memberAttachments-pagination', itemsPerPage: pageSize, currentPage: pageNumber, totalItems: pageCount } ">
                                        <td>{{item.attachmentName}}</td>
                                        <td class="options">
                                        <!-- {{item.url}} -->
                                            <i style="color: #337ab7;" class="fa text-primary fa-download pr-5"  (keyup.enter)="downloadDocument(item.url,item.attachmentName)"  (click)="downloadDocument(item.url,item.attachmentName)" title="{{'documentlibrary.download '|translate | translateKey}}">
                                            </i>&nbsp;&nbsp;&nbsp;
                                            <i class="line-height1-2 fa fa-trash" (keyup.enter)="openDeleteAttachmentPopUp(item)" (click)="openDeleteAttachmentPopUp(item)" title="{{'ticketing-system.Delete'|translate | translateKey}}">
                                            </i>
                                        </td>
                                    </tr>
                                </tbody>
                                <!-- <tbody>
                                    <tr>
                                        <td  colspan="2" class="text-center">{{'ticketing-system.Max 15 attachments allowed'|translate | translateKey}}</td>
                                    </tr>
                                </tbody>                                         -->
                                <tbody *ngIf="pageCount===0">
                                    <tr>
                                        <td  colspan="2" class="text-center">{{'ticketing-system.No attachments found.'|translate | translateKey}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="alert-white rounded grid-count">
                         {{pageCount}} {{'ticketing-system.record(s) found' |translate}}
                         <pagination-controls [id]="paginationInstance.id" (pageChange)="pageChange($event)" class="pull-right"></pagination-controls>
                         </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>



// WEBPACK FOOTER //
// ./src/app/customerservice/templates/template1/views/member-notes.component.html